/**
 * @file 任务列配置
 */

 const countryColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'title',
	label: '项目标题',
	slot: 'title'
}, {
	prop: 'bidType',
	label: '信息类型'
}, {
	prop: 'province',
	label: '省份'
}, {
	prop: 'city',
	label: '城市'
}, {
	prop: 'oneTradeName',
	label: '一级行业'
}, {
	prop: 'twoTradeName',
	label: '二级行业'
}, {
	prop: 'releaseTime',
	label: '发布时间',
	width: '160'
}, {
	prop: 'crawlTime',
	label: '抓取时间',
	width: '160'
}, {
	prop: 'authTime',
	label: '审核时间',
	width: '160'
}, {
	prop: 'authUserName',
	label: '审核人'
}, {
	prop: 'authStatusStr',
	label: '状态'
}, {
    label: '操作',
    slot: 'operate'
}];


const policyColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'title',
	label: '政策标题',
	slot: 'title',
	width: 150
}, {
	prop: 'infoType',
	label: '政策类型'
}, {
	prop: 'releaseTime',
	label: '发布时间',
	width: '160'
}, {
	prop: 'crawlTime',
	label: '抓取时间',
	width: '160'
}, {
	prop: 'authTime',
	label: '审核时间',
	width: '160'
}, {
	prop: 'authUserName',
	label: '审核人'
}, {
	prop: 'authStatusStr',
	label: '审核状态'
}, {
    label: '操作',
    slot: 'operate'
}];

const authColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
},{
	prop: 'name',
	label: '权限名称',
	width: '130'
}, {
	prop: 'code',
	label: '备注'
}, {
	prop: 'shortCode',
	label: '创建人'
}, {
	prop: 'createTime',
	label: '创建时间',
	width: '180'
}, {
    label: '操作',
    slot: 'operate'
}];

const carouselColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
},{
	prop: 'name',
	label: '轮播图名称',
	width: '130'
},{
	prop: 'typeName',
	label: '图片类型',

}, {
	prop: 'address',
	label: '图片',
	slot: 'address'
}, {
	prop: 'sort',
	label: '轮播位置'
}, {
	prop: 'linkType',
	label: '跳转类型'
}, {
	prop: 'startTime',
	label: '开始时间',
	width: '160'
}, {
	prop: 'endTime',
	label: '结束时间',
	width: '160'
}, {
	prop: 'photoStatusStr',
	label: '展示状态'
}, {
	prop: 'createTime',
	label: '禁用状态',
    slot: 'disableState'
}, {
    label: '操作',
    slot: 'operate'
}];
const accountColumns = [{
    label: "序号",
    width: "50",
    type: "index"
},
{
    prop: "accountNumber",
    label: "用户账号",
    width: "130"
},
{
    prop: "name",
    label: "用户姓名"
},
{
    prop: "phoneNum",
    label: "手机号"
},
{
    prop: "jurisdiction",
    label: "用户权限"
},
{
    prop: "remarks",
    label: "备注"
},
{
    prop: "status",
    label: "用户状态"
},
{
    prop: "founder",
    label: "创建人"
},
{
    prop: "creationDate",
    label: "创建日期"
},
{
    label: "操作",
    slot: "operate"
}];

const userColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'userName',
	label: '用户姓名',
	width: 140
}, {
	prop: 'mobile',
	label: '手机号码',
	width: 120
}, {
	prop: 'company',
	label: '公司名称',
	width: '160'
}, {
	prop: 'areaInfo',
	label: '所在地区',
	width: '160'
}, {
	prop: 'vipStr',
	label: '会员级别'
}, {
	prop: 'createDate',
	label: '注册时间',
	width: 160
}, {
	prop: 'vipExpireTime',
	label: 'vip到期时间',
	width: 160
}, {
	prop: 'status',
	label: '状态',
	slot: 'status'
}, {
    label: '操作',
    slot: 'operate'
}];


// 发布招标
const bidColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'title',
	label: '项目标题',
	slot: 'title'
}, {
	prop: 'releaseTime',
	label: '发布时间'
}, {
	prop: 'area',
	label: '招标所在地'
}, {
	prop: 'bidMoney',
	label: '标的物金额(元)',
    width: 120
}, {
	prop: 'authStatusStr',
	label: '审核状态'
}, {
	prop: 'authUserName',
	label: '审核人'
}, {
    label: '操作',
    slot: 'operate'
}];

// 发布招标
const letterColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'letterTypeName',
	label: '保函类型'
}, {
	prop: 'letterAgencyName',
	label: '出函机构'
}, {
	prop: 'mobile',
	label: '联系电话',
    width: 90
},{
	prop: 'createTime',
	label: '下单时间',
    width: 160
}, {
	prop: 'authStatusStr',
	label: '跟进状态'
}, {
	prop: 'authUserName',
	label: '跟进人'
}, {
	prop: 'authTime',
	label: '跟进时间',
    width: 160
},  {
    label: '操作',
    slot: 'operate'
}];


const orderMallColumns =[{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'name',
	label: '购买内容'
}, {
	prop: 'contactInfo',
	label: '联系方式'
}, {
	prop: 'tradeInfo',
	label: '行业'
}, {
	prop: 'area',
	label: '区域'
}, {
	prop: 'submitTime',
	label: '下单时间',
    width: 160
}, {
	prop: 'authStatusStr',
	label: '跟进状态'
}, {
	prop: 'authUserName',
	label: '跟进人'
}, {
	prop: 'authTime',
	label: '跟进时间',
    width: 160
},  {
    label: '操作',
    slot: 'operate'
}];


const auditMallColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
	prop: 'title',
	label: '项目标题',
    slot: 'title'
}, {
    label: '头图',
    slot: 'img'
}, {
	prop: 'firstTradeName',
	label: '一级行业'
}, {
	prop: 'secondTradeName',
	label: '二级行业'
}, {
	prop: 'provinceName',
	label: '省份'
}, {
	prop: 'cityName',
	label: '城市'
}, {
	prop: 'keywords',
	label: '关键词'
}, {
    prop: 'column',
    label: '报告目录'
}, {
	prop: 'price',
	label: '价格'
}, {
	prop: 'publishTime',
	label: '发布日期',
    width: 150
}, {
	prop: 'type',
	label: '频道栏目',
    formatter(row) {
		return row.type === 0 ? '所有栏目' : '专题频道';
	}
}, {
    label: '操作',
    slot: 'operate'
}];

const financeColumns = [{
    label: '序号',
    width: '50',
    type: 'index'
}, {
    label: '贷款用途',
    prop: 'financeUseDirect'
}, {
	prop: 'financeMoney',
	label: '贷款额度'
}, {
	prop: 'financeCycle',
	label: '贷款周期'
}, {
	prop: 'financeType',
	label: '贷款性质'
}, {
	prop: 'financeMobile',
	label: '联系人电话',
    width: 120
}, {
	prop: 'createTime',
	label: '下单时间',
    width: 160
}, {
	prop: 'followStatusName',
	label: '跟进状态'
}, {
	prop: 'followUser',
	label: '跟进人'
}, {
	prop: 'followTime',
	label: '跟进时间',
    width: 160
},  {
    label: '操作',
    slot: 'operate'
}];

export default {
    policyColumns, countryColumns, authColumns, carouselColumns, accountColumns, userColumns, bidColumns, letterColumns, orderMallColumns,
    auditMallColumns, financeColumns
};
